(function () {
  if (window.__nestThemeV2PdpPriceCommaWrapper20260624) return;
  window.__nestThemeV2PdpPriceCommaWrapper20260624 = true;

  var previousScript = 'theme-v2-before-pdp-price-comma-fix-20260624.js';
  var priceFixScript = 'pdp-variant-price-comma-fix-20260624.js';

  function assetUrl(filename) {
    var script = document.currentScript;
    if (script && script.src) {
      try {
        return new URL(filename, script.src).toString();
      } catch (error) {}
    }
    return filename;
  }

  function loadScript(src, async) {
    if (document.readyState === 'loading' && async === false) {
      document.write('<script src="' + src.replace(/"/g, '&quot;') + '"><\\/script>');
      return;
    }

    var script = document.createElement('script');
    script.src = src;
    script.async = async !== false;
    (document.head || document.documentElement).appendChild(script);
  }

  loadScript(assetUrl(previousScript), false);
  loadScript(assetUrl(priceFixScript), true);
})();
